import React from "react";
import CashFlow from "../components/Finance/CashFlow";

const Finance: React.FC = () => {
  return <CashFlow />;
};

export default Finance;

